import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const supportData = [
    {
        category: "Shipment Status",
        items: [
            {
                question: "How can I track my shipment?",
                answer: "You can track your shipment on our website using your AWB or tracking number.",
            },
            {
                question: "Why is my package delayed?",
                answer:
                    "Your delivery may get delayed due to unforeseen circumstances. A new delivery timeframe will be shared with you when you track your shipment on our website. In case you have additional questions or concerns, please raise a support ticket from here or call +91-8069856101.",
            },
            {
                question: "My shipment status is still at 'Pick up.' What should I do?",
                answer:
                    "Please allow some time for your shipment to be scanned and updated. If the status doesn't change, contact our support team.",
            },
            {
                question: "My shipment is out for delivery. When will I receive it?",
                answer:
                    "Deliveries are typically completed the same day once marked 'Out for Delivery.' Please allow up to 8 hours.",
            },
        ],
    },
    {
        category: "Destination and Contact Details",
        items: [
            {
                question: "How do I change my delivery address after an order was placed?",
                answer:
                    "As a delivery partner, we cannot change your address at our end. Please contact the seller or use the order details section of our mobile app if applicable.",
            },
            {
                question: "How can I add an alternate phone number to my order?",
                answer:
                    "For security reasons, phone number changes are not allowed after shipping. Please contact support if needed.",
            },
        ],
    },
    {
        category: "Returns & Refunds",
        items: [
            {
                question: "What do I do if there is a delay in the pickup of my return shipment?",
                answer:
                    "Due to unforeseen circumstances, your pickup may be delayed. Please raise a support ticket from the tracking page here.",
            },
            {
                question: "What do I do if I haven't received the refund of my returned shipment?",
                answer:
                    "Refunds typically take 5-7 working days. If it exceeds this timeframe, please contact support.",
            },
        ],
    },
];

export default function HelpCenterPage() {
    const [open, setOpen] = useState(null);

    return (
        <section className="w-full bg-gray-50 py-10">
            <div className="max-w-5xl mx-auto px-4">
                <h1 className="text-3xl font-bold text-gray-800 mb-6">
                    Help Center
                </h1>
                {supportData.map((section, i) => (
                    <div key={i} className="mb-8">
                        <h2 className="text-xl font-semibold text-gray-700 mb-4">{section.category}</h2>
                        <div className="space-y-3">
                            {section.items.map((item, j) => {
                                const idx = `${i}-${j}`;
                                const isOpen = open === idx;
                                return (
                                    <div
                                        key={idx}
                                        className="bg-white border border-gray-200 rounded-lg"
                                    >
                                        <button
                                            className="w-full flex justify-between items-center px-4 py-3 text-left"
                                            onClick={() => setOpen(isOpen ? null : idx)}
                                        >
                                            <span className="font-medium text-gray-800">{item.question}</span>
                                            {isOpen ? (
                                                <ChevronUp className="w-5 h-5 text-gray-500" />
                                            ) : (
                                                <ChevronDown className="w-5 h-5 text-gray-500" />
                                            )}
                                        </button>
                                        {isOpen && (
                                            <div className="px-4 pb-4 text-gray-600 text-sm">
                                                {item.answer}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}

                <div className="mt-10 bg-[#211f57] text-white rounded-lg p-6 text-center">
                    <h3 className="text-2xl font-semibold mb-2">Need More Help?</h3>
                    <p className="mb-4 text-gray-300">Reach out to our support team anytime.</p>
                    <div className="flex justify-center gap-4 flex-wrap">
                        <a
                            href="tel:+918069856101"
                            className="bg-red-600 px-5 py-2 rounded font-semibold hover:bg-red-700 transition"
                        >
                            Call Us
                        </a>
                        <a
                            href="mailto:support@yourlogistics.com"
                            className="border border-white px-5 py-2 rounded font-semibold hover:bg-white hover:text-[#211f57] transition"
                        >
                            Email Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
